import React, { Fragment, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';


function SearchBar ({ searchQuery, updateSearchQuery, searchVideos }) {
  const searchBarRef = useRef(null);

  useEffect(() => {
    searchBarRef.current.focus();
  }, []);

  return (
    <Fragment>
      <div className="search_item">
        <strong className="screen_out">검색</strong>
        <div className="inp_text">
          <input ref={searchBarRef} type="text" placeholder="검색어를 입력하세요." title="검색"
            value={searchQuery} onChange={updateSearchQuery} onKeyPress={handleEnterPress}/>
        </div>
        <a href="#" role="button" className="btn_search" onClick={searchVideos}>
          <span className="ico_editor ico_search">검색</span>
        </a>
      </div>
      <a href="https://www.youtube.com" rel="noreferrer" target="_blank" className="txt_producer">
        Powered by YouTube
      </a>
    </Fragment>
  );

  function handleEnterPress ({ key }) {
    if (key === 'Enter') {
      searchVideos();
    }
  }
}

SearchBar.propTypes = {
  searchQuery: PropTypes.string,
  updateSearchQuery: PropTypes.func,
  searchVideos: PropTypes.func,
};

export default SearchBar;
